import SectionHeading from "components/common/SectionHeading";
import ScrollReveal from "components/common/ScrollReveal";
import CybersecurityImg from "assets/images/cybersecurity.svg";
import DataAnalysisImg from "assets/images/data-analysis.svg";
import ProcessImg from "assets/images/process.svg";
import IntegrationImg from "assets/images/integration.svg";

const FEATURES = [
    {
        image: CybersecurityImg,
        title: "Enterprise Security",
        description:
            "Advanced threat detection, SOC monitoring, and compliance management to protect your digital assets around the clock.",
    },
    {
        image: DataAnalysisImg,
        title: "Data Intelligence",
        description:
            "End-to-end data lifecycle management with governance, compliance, and analytics that turn information into insight.",
    },
    {
        image: ProcessImg,
        title: "Process Automation",
        description:
            "Intelligent RPA and workflow automation that eliminates manual tasks and accelerates business operations.",
    },
    {
        image: IntegrationImg,
        title: "Seamless Integration",
        description:
            "Connect legacy systems, cloud platforms, and modern tools with robust API and data integration solutions.",
    },
];

const WhyChooseUs = () => {
    return (
        <section className="light-bg gradient-mesh">
            <div className="container">
                <SectionHeading
                    eyebrow="Why Adroit Systems"
                    title="Trusted partner for digital transformation"
                    description="We combine deep technical expertise with industry best practices to deliver IT solutions that drive measurable business outcomes."
                />
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                    {FEATURES.map((feature, index) => (
                        <ScrollReveal
                            key={feature.title}
                            variant="up"
                            delay={index * 120}
                        >
                            <div className="feature-card h-full">
                                <div className="w-full aspect-square max-w-[120px] mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary/[0.05] p-4">
                                    <img
                                        src={feature.image}
                                        alt={feature.title}
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                                <h3 className="text-lg font-bold text-black mb-3 text-center">
                                    {feature.title}
                                </h3>
                                <p className="text-sm md:text-base text-secondary/70 text-center leading-relaxed">
                                    {feature.description}
                                </p>
                            </div>
                        </ScrollReveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
